import Hotjar from '@hotjar/browser';
import { initGtag } from '../../../packages/src/analytics/gtag-init.js';
import { initEnvValue } from '../../../packages/src/envs/index.js';
import {
  print,
  addVisitDateInfo,
  regByWebappIdFirstStep1,
  regByWebappIdFirstStep2,
  captureEvents,
} from '../../../packages/src/api/index.js';
import * as utilsModules from './utils-module.js';
import { initGalleryViewController } from './imageList.js';
import { initModeSwitcher } from './modeSwitcher.js';
import { initSelect } from './select.js';
import { initItemCounter } from './itemCounter.js';
import { initActionPanel } from './actionPanel.js';
import { initTopPanelSelectForShoppingCart } from './topPanelSelectForShoppingCart.js';
import { initSelectedPanel } from './panel-selected.js';
import * as photoDC from './photoDS.js';
import { initWaitingNotice } from './waitingNotice.js';
import * as fullScreenView from './fullScreenView.js';
import { init as initZendesk } from './zendesk.js';

function forceHideLoadingOverlay() {
  const overlay = document.querySelector('.screenOverlay');
  const spinner = document.getElementById('cssload-cupcake');
  if (overlay) {
    overlay.style.display = 'none';
  }
  if (spinner) {
    spinner.style.display = 'none';
  }
}

forceHideLoadingOverlay();
window.addEventListener('pageshow', forceHideLoadingOverlay);
window.addEventListener('pagehide', forceHideLoadingOverlay);

// Envs
initEnvValue('BACKEND_API', process.env.BACKEND_API);

window.addVisitDateInfo = addVisitDateInfo;
window.print = print;
window.regByWebappIdFirstStep1 = regByWebappIdFirstStep1;
window.regByWebappIdFirstStep2 = regByWebappIdFirstStep2;
window.captureEvents = captureEvents;
window.fullScreenView = fullScreenView;

Object.keys(utilsModules).forEach((name) => {
  window[name] = utilsModules[name];
});

window.initGalleryViewController = initGalleryViewController;
window.initModeSwitcher = initModeSwitcher;
window.initSelect = initSelect;
window.initItemCounter = initItemCounter;
window.initActionPanel = initActionPanel;
window.initTopPanelSelectForShoppingCart = initTopPanelSelectForShoppingCart;
window.initSelectedPanel = initSelectedPanel;
window.photoDC = photoDC;

window.initWaitingNotice = initWaitingNotice;
window.initZendesk = initZendesk;

if (process.env.WEBPAPP_HOTJAR_ID) {
  Hotjar.init(process.env.WEBPAPP_HOTJAR_ID, 6);
}

initGtag(process.env.GA_MEASUREMENT_ID);
